import { SET_ACTIVE_MODAL } from './types';

const mutations = {
  [SET_ACTIVE_MODAL](state, { name, val, stacking }) {
    const activeModals = stacking ? [...state.activeModals] : [];
    const i = activeModals.indexOf(name);

    if (i >= 0) {
      if ((typeof val === 'undefined')
      || ((typeof val === 'boolean') && !val)) {
        activeModals.splice(i, 1);
      }
    } else {
      if ((typeof val === 'undefined')
      || ((typeof val === 'boolean') && val)) {
        activeModals.push(name);
      }
    }

    state.activeModals = activeModals;
  }
};

export default mutations;
